export const getModalWidh = () => {
  const width = window.innerWidth;
  let result;
  if(width > 1624){
    result = '25%'
  }else if(width > 1424){
    result = '30%'
  }else if(width > 1224){
    result = '35%'
  }else if(width > 1024){
    result = '40%'
  }else if(width > 724){
    result = '60%'
  }else if(width > 524){
    result = '75%'
  }else{
    result = '90%'
  }
  return result;
};

export const getTossModalWidh = () => {
  const width = window.innerWidth;
  let result;
  if(width > 1624){
    result = '30%'
  }else if(width > 1424){
    result = '35%'
  }else if(width > 1224){
    result = '40%'
  }else if(width > 1024){
    result = '45%'
  }else if(width > 724){
    result = '65%'
  }else if(width > 524){
    result = '80%'
  }else{
    result = '90%'
  }
  return result;
};

export const getSemiBigModalWidh = () => {
  const width = window.innerWidth;
  let result;
  if(width > 1624){
    result = '32%'
  }else if(width > 1424){
    result = '36%'
  }else if(width > 1224){
    result = '40%'
  }else if(width > 1024){
    result = '44%'
  }else if(width > 724){
    result = '60%'
  }else if(width > 524){
    result = '70%'
  }else{
    result = '80%'
  }
  return result;
};

export const getBigModalWidh = () => {
  const width = window.innerWidth;
  let result;
  if(width > 1424){
    result = '40%'
  }else if(width > 1224){
    result = '50%'
  }else if(width > 1024){
    result = '60%'
  }else if(width > 724){
    result = '70%'
  }else{
    result = '90%'
  }
  return result;
};


// export default {
//   getModalWidh,
//   getBigModalWidh
// };
